import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import "../component/css/childdetails.css";
import "../component/css/emergencycontact.css";
import axios, { isAxiosError } from "axios";
import { useDispatch, useSelector } from "react-redux";
import Alert from "@mui/material/Alert";
import { sanitizeInput } from "../utils/sanitizeInput";
import { updateFormData, submitFormData } from "../redux/actions";
import { DAYCARE_ID, SERVER_URL, serverURL } from "../config";
import CustomSelect from "./helpers/CustomSelect";

function Submission({ Back, initalScreen }) {
  const dispatch = useDispatch();
  const { daycareId, daycareCode } = useParams();
  const currentDaycareId = daycareId && daycareCode ? `${daycareId}/${daycareCode}` : DAYCARE_ID;
  const [success, setSuccess] = useState("");
  const [applicationID, setApplicationId] = useState("");
  const [siblings, setSiblings] = useState([
    { siblingName: "", siblingDOB: "" },
  ]);

  const [err, setErrs] = useState("");
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [copied, setCopied] = useState(false);

  const formData = useSelector((state) => state.formData);
  const keywordLabels = useSelector((state) => state.keywordLabels);
  const schoolDetails = useSelector((state) => state.schoolDetails);
  //have a function to handle change of the siblings
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    const cleanedValue = sanitizeInput(value);
    dispatch(updateFormData({ [name]: cleanedValue }));
  };

  const [hearAboutUs, setHearAboutUs] = useState("");
  const [errors, setErrors] = useState("");
  const [isSubmitted, setIsSubmitted] = useState(false);

  const [validSubmittedBy, setValidSubmittedBy] = useState(true);

  const setValidationErrors = (err) => {
    setErrs(err);
  };


  const getApplicationId = async () => {
    try {
      if (!applicationID) {
        const { data } = await axios.get(
          `${SERVER_URL}getApplicationIdV2/${currentDaycareId}`
        );
        setApplicationId(data.applicationID);
      } else {
        return;
      }
    } catch (e) {
      // console.log(e);
      setErrors("Failed to fetch an ID for the application.");
    }
  };
  useEffect(() => {
    getApplicationId();
  }, []);

  const handleHearAboutUsChange = (event) => {
    const inputValue = event.target.value;
    setHearAboutUs(inputValue);
  };

  const handleSubmittedByBlur = (e) => {
    const inputValue = e.target.value;
    if (inputValue.trim() === "") {
      setValidSubmittedBy(false)
      setValidationErrors("Please select how you hear about us.");
    } else {
      setValidSubmittedBy(true)
      setErrs('')

    }
  };

  const handleSubmit = async () => {
    try {
      if (!formData?.howDidYouHearAboutUS) {
        return setErrs("You must select how did you hear about us.");
      }
      setErrs("");

      setErrs("");
      formData.daycare_id = schoolDetails?._id || currentDaycareId;
      formData.applicationID = applicationID;
      console.log({ formData });
      console.log(typeof formData?.siblings);
      if (Array.isArray(formData?.siblings)) {
        formData.siblings = JSON.stringify(formData?.siblings);
      }


      if (formData.applicationId && formData.applicationID) {
        delete formData.applicationId;
      }
      const { data } = await axios.post(`${SERVER_URL}enrollChild`, formData);
      console.log(data);
      setSuccess("Form submitted successfully!");
      setFormSubmitted(true); // <-- important
      localStorage.removeItem('age');
    } catch (e) {
      setErrors("Something went wrong");
      console.log(e);
    }
  };


  const handleGoBack = () => {
    dispatch(submitFormData());
    initalScreen();
  };

  const handleCopyApplicationNumber = () => {
    navigator.clipboard.writeText(applicationID).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }).catch(err => {
      console.error('Failed to copy:', err);
    });
  };
  return (
    <>
      {formSubmitted ? (
        <section className="child-main-sec">
          <div className="main-sec submission-success">
            <div className="main-head">
              <h1 className="font-fmly font-fml">
                <span>{keywordLabels?.orgName || "Sparkle"}</span> {keywordLabels?.child || "Child"} Admission Form
              </h1>
              <span>{formData?.applicationId}</span>
            </div>
            <div className="success-panel">
              <div className="success-mark" aria-hidden="true">Success</div>
              <h2>Thank you for submitting the admission form.</h2>
              <p>
                Your Application Number: <strong>{applicationID}</strong>
              </p>
              <button
                onClick={handleCopyApplicationNumber}
                className={`button copy-application-button ${copied ? "copied" : ""}`}
              >
                {copied ? "Copied" : "Copy Application Number"}
              </button>
              <p className="success-note">
                Please save this number for future reference and communication.
              </p>
            </div>
          </div>
        </section>
      ) : (
        <section className="child-main-sec">
          <div className="main-sec">
            <div className="main-head">
              <h1 className="font-fmly font-fml">
                <span>{keywordLabels?.orgName || "Sparkle"}</span> {keywordLabels?.child || "Child"} Admission Form
              </h1>
              <span>{formData?.applicationId}</span>
            </div>
            {errors.length !== 0 ? (
              <Alert severity="error" className="arror-find">{errors}</Alert>
            ) : null}
            {success.length !== 0 ? (
              <Alert severity="success">
                {success}{" "}
                <b
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    handleGoBack();
                  }}

                >
                  Click here to go back to the initial form
                </b>
              </Alert>
            ) : null}



            <div className="head-sec">
              <div className="para-sec">
                <h3>Submission</h3>
              </div>
            </div>
            <div style={{ minHeight: '20px' }}> {/* adjust height as needed */}
              {err.length !== 0 ? (
                <Alert severity="error" className="arror-find">
                  {err}
                </Alert>
              ) : null}
            </div>

            <div className="input-main  pdg">
              <div className="inp-tell-1 inp-tell">
                <label className='my-label'>Comment</label>
                <input
                  name="comment"
                  value={formData?.comment}
                  type="text"
                  placeholder=""
                  onChange={(e) => {
                    handleInputChange(e);
                  }}
                  className="input inp-sub-form"
                />
              </div>



              <div className="inp-tell-1 inp-tell left">
                <label className='my-label'>how did you hear about us?*</label>
                <CustomSelect
                  onChange={(e) => {
                    handleHearAboutUsChange(e);
                    handleInputChange(e);
                  }}
                  value={formData?.howDidYouHearAboutUS}
                  className="input drop-down-inp"
                  name="howDidYouHearAboutUS"
                  style={validSubmittedBy ? {} : { border: '1px solid red' }}

                  onBlur={(e) => {
                    handleSubmittedByBlur(e);
                  }}


                >
                  <option disabled selected>
                    <span id="span"> </span>
                  </option>
                  <option>From A Friend/Colleague</option>
                  <option>From Our Website</option>
                  <option>From An Existing Parent</option>
                  <option>From The Staff Member</option>
                  <option>Others</option>
                </CustomSelect>

                {/* <p>Selected Session: {selectedSession}</p> */}
              </div>

            </div>


            <div className="form-footer">
              <div className="btn-left">

                <button className="button pdg back" onClick={Back}>
                  Back
                </button>
              </div>

              <div className="btn-right">
                <button
                  className={`button pdg  ${success.length !== 0 ? "disabled" : null
                    }`}
                  disabled={success.length !== 0 ? true : false}
                  onClick={() => {
                    handleSubmit();
                  }}
                >
                  Submit
                </button>
                {isSubmitted && <p>Application submitted successfully!</p>}

              </div>
            </div>




            {/*
          <div className="btn-parent">
            <div className="btn-p">
              <div className="btn-pc">
                <button className="button pdg back" onClick={Back}>
                  Back
                </button>
              </div>
              <div className="btn-pc">
                <button
                  className={`button pdg ${success.length !== 0 ? "disabled" : null
                    }`}
                  disabled={success.length !== 0 ? true : false}
                  onClick={() => {
                    handleSubmit();
                  }}
                >
                  submit
                </button>
                {isSubmitted && <p>Application submitted successfully!</p>}
              </div>
            </div>
          </div>


          */}
          </div>
        </section>
      )}
    </>
  );
}

export default Submission;
